import { createSlice } from '@reduxjs/toolkit';
import { getCourses, getCoursesAccordion } from 'reduxStore/actions/courses';

const initialState = {
  userLoading: false,
  courses: [],
  coursesAccordion: [],
  error: null,
};

const coursesSlice = createSlice({
  name: 'courses',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCourses.fulfilled, (state, action) => {
        state.userLoading = false;
        state.courses = action.payload.data;
      })
      .addCase(getCoursesAccordion.fulfilled, (state, action) => {
        state.userLoading = false;
        state.coursesAccordion = action.payload.data;
      })
      .addCase(getCourses.pending, (state) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getCoursesAccordion.pending, (state, action) => {
        state.userLoading = true;
        state.error = null;
      })
      .addCase(getCourses.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      })
      .addCase(getCoursesAccordion.rejected, (state, action) => {
        state.userLoading = false;
        state.error = action.payload;
      });
  },
});

export default coursesSlice.reducer;
